import TransactionForm from '../components/TransactionForm';

export default function NewTransaction() {
  return (
    <div className="space-y-5" data-testid="new-transaction-page">
      <h1 className="font-display text-3xl text-ink tracking-tight">Order Sewa Baru</h1>
      <TransactionForm />
    </div>
  );
}
